export const STORE_API = '/api/dashboard/digital-store'

export const STORES_API = `${STORE_API}/digital-stores`

export const HEADER_ITEM_API = `${STORE_API}/item-headers`
export const getHeaderItemPostPath = (storeId: number) =>
  `${STORE_API}/digital-stores/${storeId}/item-headers`

export const LINK_ITEM_API = `${STORE_API}/item-links`
export const getLinkItemPostPath = (storeId: number) =>
  `${STORE_API}/digital-stores/${storeId}/item-links`

export const OPTIN_ITEM_API = `${STORE_API}/item-opt-ins`
export const getOptInItemPostPath = (storeId: number) =>
  `${STORE_API}/digital-stores/${storeId}/item-opt-ins`

export const PRODUCT_ITEM_API = `${STORE_API}/item-products`
export const getProductItemPostPath = (storeId: number) =>
  `${STORE_API}/digital-stores/${storeId}/item-products`

export const E_COURSE_ITEM_API = `${STORE_API}/item-courses`
export const getCourseItemPostPath = (storeId: number) =>
  `${STORE_API}/digital-stores/${storeId}/item-courses`

export const PHYSICAL_PRODUCT_ITEM_API = `${STORE_API}/item-physical-products`
export const getPhysicalProductItemPostPath = (storeId: number) =>
  `${STORE_API}/digital-stores/${storeId}/item-physical-products`
